import axios from 'axios';

export default {
    validateLogin(employeeCode, password) {
        return axios.post('/user/validateLogin/', {
            employeeCode: employeeCode,
            passwd: password,
        });
    },
    validateApiLogin(employeeCode, password) {
        return axios.post('[API]/login', {
            employee_code: employeeCode,
            password,
            type: 'pin',
            environment: 'ERP',
        });
    },
    refreshApiToken() {
        return axios.get('[API]/refresh-token', {
            headers: {
                'X-Environment': 'ERP',
            },
        });
    },
    listUsers() {
        return axios.post('/user/list/');
    },
    fetchCurrentEmployeeDetails() {
        return axios.post('/user/details/');
    },
    fetchUserDetails(userId) {
        return axios.post('/user/userdetails/', { userId });
    },
    deleteUser(userId) {
        return axios.post('/user/delete/', { userId });
    },
    updateUserPassword(userId, password) {
        return axios.post('/user/updatepassword/', { userId, password });
    },
};
